// Unified API Client for Web and React Native

let authToken = null;
let apiBaseUrl = (typeof process !== 'undefined' && process.env && (process.env.REACT_APP_API_URL || process.env.EXPO_PUBLIC_API_URL)) || '';



// Default token storage adapter (falls back to memory or localStorage in browser)
let tokenStorage = {
  get: () => {
    if (authToken) return authToken;
    if (typeof window !== 'undefined' && window.localStorage) {
      return window.localStorage.getItem('recipe_auth_token');
    }
    return null;
  },
  set: (token) => {
    authToken = token;
    if (typeof window !== 'undefined' && window.localStorage) {
      if (token) {
        window.localStorage.setItem('recipe_auth_token', token);
      } else {
        window.localStorage.removeItem('recipe_auth_token');
      }
    }
  },
  remove: () => {
    authToken = null;
    if (typeof window !== 'undefined' && window.localStorage) {
      window.localStorage.removeItem('recipe_auth_token');
    }
  },
};

/**
 * Configure token storage for custom environments (e.g. AsyncStorage in React Native)
 * @param {{ get: () => Promise<string>|string, set: (token: string) => Promise<void>|void, remove: () => Promise<void>|void }} adapter
 */
export function setTokenStorageAdapter(adapter) {
  tokenStorage = adapter;
}

/**
 * Set the API base URL (e.g., 'https://recipe4me-api.jiayz1997.workers.dev' or '/api')
 */
export function setApiBaseUrl(url) {
  apiBaseUrl = (url || '').replace(/\/+$/, '');
}

export function getApiBaseUrl() {
  return apiBaseUrl;
}

export async function getAuthToken() {
  return await tokenStorage.get();
}

export async function setAuthToken(token) {
  authToken = token;
  await tokenStorage.set(token);
}

export async function clearAuthToken() {
  authToken = null;
  await tokenStorage.remove();
}

/**
 * Core HTTP request wrapper with JWT authentication
 */
export async function request(endpoint, options = {}) {
  const url = endpoint.startsWith('http')
    ? endpoint
    : `${apiBaseUrl}${endpoint.startsWith('/') ? endpoint : `/${endpoint}`}`;

  const headers = {
    'Content-Type': 'application/json',
    ...(options.headers || {}),
  };

  const token = await getAuthToken();
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const response = await fetch(url, {
    ...options,
    headers,
  });

  const contentType = response.headers.get('content-type');
  let data = null;
  if (contentType && contentType.includes('application/json')) {
    data = await response.json();
  } else {
    data = await response.text();
  }

  if (!response.ok) {
    const errorMessage = (typeof data === 'object' && data?.error) || `Request failed with status ${response.status}`;
    const error = new Error(errorMessage);
    error.status = response.status;
    error.data = data;
    throw error;
  }

  return data;
}
